import DocumentBlock from './DocumentBlock'

function SectionHead({ section, as: Tag = 'h2' }) {
  if (!section.eyebrow && !section.title) return null
  return (
    <header className="space-y-1 break-after-avoid">
      {section.eyebrow && <p className="text-[11px] font-semibold uppercase tracking-[0.13em] text-gray-500">{section.eyebrow}</p>}
      {section.title && (
        <Tag className={Tag === 'h1' ? 'text-3xl sm:text-4xl font-bold tracking-tight text-gray-900' : 'text-2xl font-semibold tracking-tight text-gray-900'}>
          {section.title}
        </Tag>
      )}
    </header>
  )
}

// VH-228 phase 0: a stored block document — sections in order, each with its blocks.
export function CycleDocumentBody({ content }) {
  const sections = content?.sections ?? []
  return (
    <div className="space-y-10 print:space-y-6 text-gray-900" data-testid="cycle-document-body">
      {sections.map((section) => {
        const blocks = section.blocks.map((block, i) => <DocumentBlock key={i} block={block} />)
        if (section.variant === 'hero') {
          return (
            <section key={section.id} id={`doc-${section.id}`} className="space-y-4">
              <SectionHead section={section} as="h1" />
              {blocks}
            </section>
          )
        }
        if (section.variant === 'verdict') {
          return (
            <section key={section.id} id={`doc-${section.id}`} className="rounded-lg border border-gray-200 border-l-4 border-l-teal-600 bg-surface-container p-5 space-y-3 break-inside-avoid">
              <SectionHead section={section} as="h2" />
              {blocks}
            </section>
          )
        }
        if (section.variant === 'footer') {
          return (
            <section key={section.id} id={`doc-${section.id}`} className="border-t border-gray-200 pt-6 space-y-4">
              <SectionHead section={section} />
              {blocks}
            </section>
          )
        }
        return (
          <section key={section.id} id={`doc-${section.id}`} className="border-t border-gray-200 pt-6 space-y-4 print:break-before-auto">
            <SectionHead section={section} />
            {blocks}
          </section>
        )
      })}
    </div>
  )
}

export default CycleDocumentBody
